import { basicAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const medusaJs = defineConnector({
  identifier: "medusaJs",
  name: "Medusa",
  tagLine: "Open source commerce platform",
  logo,
  protocol: "http",
  tags: ["productivity"],
  defaultUrlPattern: ({ domain }) =>
    domain
      ? `https://${domain.replace(/\./g, "\\.")}/.*`
      : "https://.*.medusajs.com/.*",
  auth: (app) =>
    basicAuth({
      username: app.secret.apiKey,
      password: "",
    }),
  steps: [
    {
      title: "Enter your Medusa instance",
      items: [
        {
          kind: "input",
          label: "Instance domain",
          required: true,
          placeholder: "your-medusa.example.com",
          target: { kind: "configuration", field: "domain" },
        },
      ],
    },
    {
      title: "Enter your API token",
      items: [
        {
          kind: "markdown",
          content:
            "Create an API token in your Medusa admin dashboard. See the [API docs](https://docs.medusajs.com/api/admin) for details.",
        },
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ domain }) => `https://${domain}/admin/products`,
  },
});
